jQuery( function( $ ) {
	$( document ).ready( function() {

		utilsJS = ( function() {

			var
				init = function() {
					_smoothScroll();
				},

				_smoothScroll = function() {
					$( 'body' ).on( 'click', 'a[href*="#"]', function( e ) {
						if ( '' !== this.hash && false !== $( this ).data( 'scroll' ) ) {
							e.preventDefault();
							var hash = this.hash;
							$( 'html, body' ).animate({
								scrollTop: $( hash ).offset().top - 100
							}, 800 );
						}
					});
				}
			;

			return {
				init: init
			};

		}() );

	});
});
